module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "homepage-mypage-community-operator-template"
    }
  }, _vm._l((_vm.operatorList), function(list) {
    return _c('li', {
      staticClass: "my-cummunity gutter-20__li grid-4"
    }, [_c('a', {
      staticClass: "my-cummunity__link request_link embed-responsive embed-responsive-4by3",
      attrs: {
        "href": "#",
        "title": "운영자 요청 중 {{list.name}}"
      },
      on: {
        "click": function($event) {
          return _vm.isAdminApprove(list.id, list.org)
        }
      }
    }, [_c('div', {
      staticClass: "my-cummunity-card board-card__media background-image",
      style: (("background-image: url(" + (list.imgUrl) + ")"))
    }, [_c('div', {
      staticClass: "my-cummunity-card__bg"
    }, [_c('label', {
      staticClass: "my-cummunity-card__label"
    }, [_vm._v("운영자 요청 중")]), _vm._v(" "), _c('h4', {
      staticClass: "my-cummunity-card__title"
    }, [_vm._v(_vm._s(list.name))])])])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-701b62f1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/community/AdminRequest.vue
// module id = 1452
// module chunks = 6